import {gql} from '@apollo/client';

const InvoicePDF = gql`
    fragment InvoicePDF on InvoicePDF {
        invoiceId
        __typename
        ... on InvoicePDFBase64 {
            data
        }
    }
`;

export const CreateInvoice = gql`
    mutation CreateInvoice(
        $requests: [InvoiceRequest!]!
        $invoiceDate: LocalDate
        $dueDate: LocalDate!
        $mode: InvoiceMode!
        $range: ClosedLocalDateRange!
        $notify: Boolean!
    ) {
        finance {
            invoices {
                create(
                    requests: $requests
                    invoiceDate: $invoiceDate
                    dueDate: $dueDate
                    mode: $mode
                    range: $range
                    notify: $notify
                ) {
                    invoices {
                        __typename
                        ... on InvoiceSuccess {
                            invoice {
                                billPayer {
                                    billPayerId
                                    name
                                }

                                pdf {
                                    ...InvoicePDF
                                }
                                invoiceDate
                                invoiceId
                                title
                                total
                                invoiceDetailsCore
                            }
                        }
                        ... on InvoiceFailure {
                            billPayer {
                                billPayerId
                                name
                            }
                            errors {
                                message
                                code
                            }
                        }
                    }
                    runs {
                        runId
                    }
                }
            }
        }
    }
    ${InvoicePDF}
`;

export const PersistBatchInvoiceWithoutPDF = gql`
    mutation PersistBatchInvoiceWithoutPDF(
        $requests: [InvoiceRequest!]!
        $invoiceDate: LocalDate
        $dueDate: LocalDate!
        $mode: InvoiceMode!
        $range: ClosedLocalDateRange!
        $notify: Boolean!
    ) {
        finance {
            invoices {
                create(
                    requests: $requests
                    invoiceDate: $invoiceDate
                    dueDate: $dueDate
                    mode: $mode
                    range: $range
                    notify: $notify
                ) {
                    invoices {
                        __typename
                        ... on InvoiceSuccess {
                            invoice {
                                billPayer {
                                    billPayerId
                                    name
                                }
                                invoiceDate
                                invoiceId
                                title
                                total
                            }
                        }
                        ... on InvoiceFailure {
                            billPayer {
                                billPayerId
                                name
                            }
                            errors {
                                message
                                code
                            }
                        }
                    }
                    runs {
                        runId
                    }
                }
            }
        }
    }
`;

export const PreviewBatchInvoiceWithoutPDF = gql`
    mutation PreviewBatchInvoiceWithoutPDF(
        $requests: [InvoiceRequest!]!
        $invoiceDate: LocalDate
        $dueDate: LocalDate!
        $mode: InvoiceMode!
        $range: ClosedLocalDateRange!
        $notify: Boolean!
    ) {
        finance {
            invoices {
                create(
                    requests: $requests
                    invoiceDate: $invoiceDate
                    dueDate: $dueDate
                    mode: $mode
                    range: $range
                    notify: $notify
                ) {
                    invoices {
                        __typename
                        ... on InvoiceSuccess {
                            invoice {
                                billPayer {
                                    billPayerId
                                    name
                                }
                                invoiceDate
                                invoiceId
                                title
                                total
                            }
                        }
                        ... on InvoiceFailure {
                            billPayer {
                                billPayerId
                                name
                            }
                            errors {
                                message
                                code
                            }
                        }
                    }
                    runs {
                        runId
                    }
                }
            }
        }
    }
`;
